<template>
  <div class="volume-component">
    <p class="big-title">volume</p>
    <div class="gainer">
      <p class="title">
        agent volume <span class="font-nomal">{{ $props.agentGainer.value }}</span>
      </p>
      <div class="range-area">
        <input
          class="range"
          type="range"
          :value="$props.agentGainer.value"
          min="0"
          max="2"
          step="0.001"
          @input="onAgentGainerValueChange"
          @change="onAgentGainerValueChange"
        />
      </div>
    </div>

    <div class="gainer">
      <p class="title">
        drone volume <span class="font-nomal">{{ $props.droneGainer.value }}</span>
      </p>
      <div class="range-area">
        <input
          class="range"
          type="range"
          :value="$props.droneGainer.value"
          min="0"
          max="2"
          step="0.001"
          @input="onDroneGainerValueChange"
          @change="onDroneGainerValueChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    agentGainer: Object,
    droneGainer: Object,
  },
  methods: {
    onAgentGainerValueChange(e) {
      this.$emit('agentGainerValueChange', e.target.value);
    },
    onDroneGainerValueChange(e) {
      this.$emit('droneGainerValueChange', e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.volume-component {
  width: 100%;
  color: #070751;

  @include spLandscape {
    position: fixed;
    right: 230px;
    bottom: 20px;
    width: 400px;
  }
}

.big-title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-weight: 500;
  margin-bottom: 22px;

  @include sp {
    margin-bottom: 16px;
  }
}

.gainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 23px;
  padding-bottom: 5px;

  @include sp {
    margin-bottom: 16px;
  }

  @include spLandscape {
    &:last-child {
      margin-bottom: 0px;
    }
  }
}

.title {
  margin-bottom: 9px;
}

.range-area {
  width: 30%;
  padding-top: 4px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.range {
  width: 100%;
  border-radius: 5px;
  background: #070751;
  outline: none;
  appearance: none;
  height: 1px;
  cursor: pointer;

  // Range Handle
  &::-webkit-slider-thumb {
    appearance: none;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #070751;
    cursor: pointer;
    transition: background 0.15s ease-in-out;

    &:hover {
      background: #fff;
      border: solid 1px #070751;
    }
  }

  &:active::-webkit-slider-thumb {
    background: #070751;
  }

  &::-moz-range-thumb {
    width: 8px;
    height: 8px;
    border: 0;
    border-radius: 50%;
    background: #070751;
    cursor: pointer;
    transition: background 0.15s ease-in-out;

    &:hover {
      background: #fff;
      border: solid 1px #070751;
    }
  }
}

.font-nomal {
  font-weight: 400;
  padding-left: 5px;
}
</style>
